"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Status = void 0;
const react_1 = __importDefault(require("react"));
const Base_1 = require("../Base");
const colors = {
    prominent: '#006CCF',
    disabled: '#C0BEB9',
    neutral: '#6E6D6A',
    info: '#8157C0',
    positive: '#1F7C53',
    caution: '#87690B',
    negative: '#C04226',
};
const Status = ({ appearance = 'info', children, ...props }) => {
    return (react_1.default.createElement(Base_1.Base, { color: colors[appearance], ...props }, children));
};
exports.Status = Status;
